import {combineReducers} from 'redux';
import Sections from './sections';
import Title from './title';
import Photo from './photo';

const rootReducer = combineReducers({
    title: Title,
    photo: Photo,
    id: id,
    sections: Sections
});

function id(state = "") {
    return state;
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/admin/components/editor/reducers/combined.js